<template>
  <soha-page-loading v-if="loading" />
  <div class="card card-custom gutter-b example example-compact p-6" v-else>
    <div class="row m-0 align-items-center justify-content-between mb-10">
      <div>
        <span class="svg svg-icon svg-icon-primary mr-3">
          <inline-svg src="/media/svg/soha/icons/headset.svg" />
        </span>
        <span class="card-label pl-1 soha-page-title">
          {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
        </span>
      </div>
      <soha-button
        :text="
          ticket.statusId != 5
            ? $t(`${I18nPrefix}CLOSE_TICKET`)
            : $t(`${I18nPrefix}OPEN_TICKET`)
        "
        name="insertText"
        @click="changeStatus()"
        :loading="changeStatusLoading"
      />
    </div>
    <div class="row m-0 justify-content-between align-items-center">
      <soha-ticket-card :ticket="ticket" />
    </div>
    <div class="row m-0">
      <div class="w-100 mt-5 font-weight-bolder">
        {{ $t(`${I18nPrefix}MESSAGES`) }}
      </div>
      <soha-timeline>
        <soha-timeline-item v-for="message in messages" :key="message.id">
          <soha-resume-timeline-box-item
            :name="`${message.firstName} ${message.lastName}`"
            :img="message.img"
            :date="messageDateFormat(message.created_at)"
            :image-icon="message.icon"
            :completeBorderRadius="false"
            :textTemplateBackground="
              message.typeId == 1
                ? 'var(--tag-light-blue-color)'
                : 'var(--muted-background-color)'
            "
            :textTemplateBorderColor="
              message.typeId == 1
                ? 'var(--tag-dark-blue-color)'
                : 'var(--box-border-light-color)'
            "
          >
            <div slot="text-template" class="soha-note-text">
              <p class="m-0" v-html="newLineToBr(message.text)" />
            </div>
          </soha-resume-timeline-box-item>
        </soha-timeline-item>
      </soha-timeline>
    </div>
    <div class="row m-0">
      <div class="w-100" v-if="ticket.statusId != 5">
        <label class="mt-2 mb-0 font-size-h6">
          {{ $t(`${I18nPrefix}TEXT`) }}
        </label>
        <soha-text-editor
          name="ticketText"
          v-model="ticketText.value"
          :style="
            ticketText.error
              ? 'border: 1px solid red !important; border-radius: 5px;'
              : ''
          "
        />
        <span class="font-size-sm text-red" v-if="ticketText.error">
          {{ $t(`${I18nPrefix}TICKET_TEXT_ERROR`) }}
        </span>
        <soha-button
          class="mt-3 float-right"
          :text="$t(`${I18nPrefix}INSERT`)"
          name="insertText"
          @click="insertText()"
          :loading="btnLoading"
        />
      </div>
      <soha-button
        v-else
        :text="$t(`${I18nPrefix}OPEN_TICKET`)"
        name="insertText"
        @click="openTicket()"
        :loading="openTicketLoading"
        class="m-auto"
      />
    </div>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin.js";
import SohaResumeTimelineBoxItem from "@/view/components/resume/ResumeTimelineBoxItem";
import ApiService from "@/core/services/api.service";
import SohaTicketCard from "@/view/components/ticket/TicketCard";
import moment from "moment-jalaali";

const CLOSE_STATUS = 5;
const OPEN_STATUS = 6;

export default {
  name: "ticketDetail",

  mixins: [UIMixin],

  components: {
    SohaResumeTimelineBoxItem,
    SohaTicketCard,
  },

  data() {
    return {
      I18nPrefix: "PAGES.TICKET.DETAIL.",
      loading: false,
      btnLoading: false,
      changeStatusLoading: false,
      openTicketLoading: false,
      ticket: {},
      ticketText: {
        value: null,
        error: null,
      },
      messages: [],
    };
  },

  mounted() {
    this.getTicket(true);
  },

  methods: {
    getTicket(loading) {
      this.loading = loading;
      ApiService.get(`api/v2/tickets/${this.$route.query.id}`).then(
        ({ data }) => {
          if (!data.code) {
            this.ticket = data.data;
            this.messages = data.data.messages;
          } else {
            this.errorToast(data.message);
          }
          this.loading = false;
        }
      );
    },

    openTicket() {
      this.openTicketLoading = true;
      ApiService.patch(`api/v2/tickets/${this.$route.query.id}`, {
        status: OPEN_STATUS,
      }).then(({ data }) => {
        if (data.code == 204) {
          this.successToast(data.message);
          this.getTicket();
        } else {
          this.errorToast(data.message);
        }
        this.openTicketLoading = false;
      });
    },

    changeStatus() {
      this.changeStatusLoading = true;
      ApiService.patch(`api/v2/tickets/${this.$route.query.id}`, {
        status:
          this.ticket.statusId != CLOSE_STATUS ? CLOSE_STATUS : OPEN_STATUS,
      }).then(({ data }) => {
        if (data.code == 204) {
          this.successToast(data.message);
          this.getTicket();
        } else {
          this.errorToast(data.message);
        }
        this.changeStatusLoading = false;
      });
    },

    insertText() {
      this.ticketText.error =
        this.ticketText.value ==
        `<p class="ql-direction-rtl ql-align-right"><br></p>`;
      if (this.ticketText.error) return;
      this.btnLoading = true;
      ApiService.post(`api/v2/tickets/${this.$route.query.id}/messages`, {
        text: this.ticketText.value,
      }).then(({ data }) => {
        if (data.code == 201) {
          this.successToast(data.message);
          this.getTicket();
          this.ticketText.value = null;
        } else {
          this.errorToast(data.message);
        }
        this.btnLoading = false;
      });
    },

    messageDateFormat(date) {
      return (
        this.$moment(date).format("dddd DD jMMMM YYYY") +
        " " +
        moment(date).format("HH:mm")
      );
    },
  },
};
</script>

<style></style>
